export default __webpack_public_path__ + "ec177978506703dc2513306959a976cc.svg";